import { useVideoStreamCtx } from '@features/video/providers';

import { TournamentVideoCard } from './TournamentVideoCard';

// Плашка видеоконтроля участника: состояние и модалка живут в VideoStreamProvider
export function TournamentVideoCardWidget() {
  const video = useVideoStreamCtx();
  if (!video?.visible) return null;
  return (
    <TournamentVideoCard
      source={video.source}
      accent={video.missing}
      status={video.status}
      error={video.error}
      micOff={video.micOff}
      camOff={video.camOff}
      onOpen={video.openModal}
    />
  );
}
